import { navigate } from 'gatsby';
import config from '../config';

export function teamSubdomainSafeNavigate(link: string): void {
    const isTeamSubdomain = typeof location !== 'undefined' && config.isTeamSubdomainPage(location);

    if (isTeamSubdomain) {
        window.location.href = `https://biolib.com${link}`;
    } else {
        navigate(link);
    }
}
